/** Right-side panel: free-form notes about the screenplay. */
export default function NotesPanel({ value, onChange }) {
  return (
    <div data-testid="sp-notes-panel">
      <h4 className="mb-3 font-serif text-base text-stone-900">Notas del guion</h4>
      <p className="mb-2 text-xs text-stone-500">
        Tema, concepto, intenciones, decisiones de tono… Útil para mantener el contexto al
        volver al proyecto.
      </p>
      <textarea
        value={value}
        onChange={(e) => onChange(e.target.value)}
        data-testid="sp-notes-textarea"
        placeholder="Tema, intención, voz del autor, decisiones de tono…"
        rows={20}
        className="w-full resize-y rounded border border-stone-300 bg-white px-3 py-2 text-sm leading-6 outline-none focus:border-[#26775E]"
      />
    </div>
  );
}
